<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "ANTENANTAL VISIT REPORT",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "VISIT REPORT",
      ante_visit: this.$route.params.ante_visit,
    };
  },
  computed: {
    ...mapGetters("reports", ["PrintAntenatalVisitReportG"]),
  },
  methods: {
    ...mapActions({
      PrintAntenatalVisitReport: "reports/printAntenatalVisitReport",
    }),
  },
  created() {
    this.PrintAntenatalVisitReport(this.$route.params.ante_visit);
  },
};
</script>
<style lang="css" scoped>
.image {
  left: 50vw;
}
.image img {
  width: 200px;
}

.stamp_date {
  position: relative;
  color: red !important;
  font-size: 20px !important;
  top: -75px;
  left: 5%;
  font-family: Verdana, Geneva, sans-serif;
}
.compla {
  display: inline-flex;
  margin-right: 2px;
  padding: 2px;
}
.p_bottom {
  margin-bottom: 8px;
}
.print {
  font-family: Verdana, Geneva, sans-serif;
}
hr {
  height: 1px;
  border-width: 0;
  color: gray;
  background-color: gray;
}
.table_qn {
  border: 1px solid gray;
  border-collapse: collapse;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print report</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title p-2">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="!PrintAntenatalVisitReportG"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="
                    PrintAntenatalVisitReportG.clinic.clinicLogo
                      ? PrintAntenatalVisitReportG.clinic.clinicLogo
                      : '---'
                  "
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{
                    PrintAntenatalVisitReportG
                      ? PrintAntenatalVisitReportG.clinic.clinicName
                      : "---"
                  }}
                </p>
                <table align="right" width="100%" style="font-size: 15px">
                  <tr align="right">
                    <td>
                      {{
                        PrintAntenatalVisitReportG
                          ? PrintAntenatalVisitReportG.clinic.clinicAddress
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      +256{{
                        PrintAntenatalVisitReportG
                          ? PrintAntenatalVisitReportG.clinic.clinicContact
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Email:</strong>
                      {{
                        PrintAntenatalVisitReportG
                          ? PrintAntenatalVisitReportG.clinic.clinicMail
                          : "---"
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12">
              <table width="100%" style="font-size: 15px">
                <tr>
                  <td>Patient Name:</td>
                  <td>
                    <b>
                      {{
                        PrintAntenatalVisitReportG
                          ? PrintAntenatalVisitReportG.patient.patient_name
                          : "---"
                      }}</b
                    >
                  </td>
                  <td>Patient Id:</td>
                  <td>
                    <b>{{
                      PrintAntenatalVisitReportG
                        ? PrintAntenatalVisitReportG.patient.patient_code
                        : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td v-if="PrintAntenatalVisitReportG.patient.gender">Gender</td>
                  <td v-if="PrintAntenatalVisitReportG.patient.gender">
                    <b>{{
                      PrintAntenatalVisitReportG.patient.gender == 1 ? "Male" : "Female"
                    }}</b>
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.visit.age">Age:</td>
                  <td v-if="PrintAntenatalVisitReportG.visit.age">
                    <b>{{
                      PrintAntenatalVisitReportG.visit.age
                        ? PrintAntenatalVisitReportG.visit.age
                        : "---"
                    }}</b>
                    <span v-if="PrintAntenatalVisitReportG.visit.age_unit == 1"
                      >Years</span
                    >
                    <span v-else-if="PrintAntenatalVisitReportG.visit.age_unit == 2"
                      >Months</span
                    >
                    <span v-else-if="PrintAntenatalVisitReportG.visit.age_unit == 3"
                      >Days</span
                    >
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr>
                  <td v-if="PrintAntenatalVisitReportG.patient.patient_contact">
                    Contact
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.patient.patient_contact">
                    <b>{{
                      PrintAntenatalVisitReportG.patient.patient_contact
                        ? PrintAntenatalVisitReportG.patient.patient_contact
                        : "---"
                    }}</b>
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.visit.weight">Weight:</td>
                  <td v-if="PrintAntenatalVisitReportG.visit.weight">
                    <b>{{
                      PrintAntenatalVisitReportG.visit.weight
                        ? PrintAntenatalVisitReportG.visit.weight + " kg"
                        : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td v-if="PrintAntenatalVisitReportG.visit.temperature">
                    Temperature:
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.visit.temperature">
                    <b>{{
                      PrintAntenatalVisitReportG.visit.temperature
                        ? PrintAntenatalVisitReportG.visit.temperature + " &#x2103;"
                        : "---"
                    }}</b>
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.visit.pressure">
                    Blood Pressure:
                  </td>
                  <td v-if="PrintAntenatalVisitReportG.visit.pressure">
                    <b>{{
                      PrintAntenatalVisitReportG.patient.pressure
                        ? PrintAntenatalVisitReportG.patient.pressure + " mmHg"
                        : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td>Visit Date:</td>
                  <td>
                    <b>{{
                      PrintAntenatalVisitReportG.visit.visitDate
                        ? PrintAntenatalVisitReportG.visit.visitDate
                        : "---"
                    }}</b>
                  </td>
                  <td>Print Date:</td>
                  <td>
                    <b>{{
                      PrintAntenatalVisitReportG.printDate
                        ? PrintAntenatalVisitReportG.printDate
                        : "---"
                    }}</b>
                  </td>
                </tr>
                <tr>
                  <td>Spouse Name:</td>
                  <td>
                    <b>{{
                      PrintAntenatalVisitReportG.spouse.spouse_name
                        ? PrintAntenatalVisitReportG.spouse.spouse_name
                        : "---"
                    }}</b>
                  </td>
                  <td>Spouse Contact:</td>
                  <td>
                    <b>{{
                      PrintAntenatalVisitReportG.spouse.spouse_contact
                        ? PrintAntenatalVisitReportG.spouse.spouse_contact
                        : "---"
                    }}</b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr style="border-style: dashed; width: 97%" />
          <div class="row">
            <div>
              <table width="100%" style="font-size: 15px">
                <tbody>
                  <tr>
                    <td>
                      Occupation :
                      <span>{{
                        PrintAntenatalVisitReportG.biodata
                          ? PrintAntenatalVisitReportG.biodata.occupation
                          : "--"
                      }}</span>
                    </td>
                    <td>
                      Religion :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.biodata
                            ? PrintAntenatalVisitReportG.biodata.religion
                            : "--"
                        }}</span
                      >
                    </td>
                    <td>
                      Tribe :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.biodata
                            ? PrintAntenatalVisitReportG.biodata.tribe
                            : "--"
                        }}</span
                      >s
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Education level :
                      <span>{{
                        PrintAntenatalVisitReportG.biodata
                          ? PrintAntenatalVisitReportG.biodata.educationlevel
                          : "--"
                      }}</span>
                    </td>
                    <td>
                      Marital Status :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.biodata
                            ? PrintAntenatalVisitReportG.biodata.marital_status
                            : "--"
                        }}</span
                      >
                    </td>
                    <td>
                      Tribe :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.biodata
                            ? PrintAntenatalVisitReportG.biodata.tribe
                            : "--"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr style="border-style: dashed; width: 97%" />
          <div class="row">
            <div>
              <table width="100%" style="font-size: 15px" class="table table-bordered">
                <tbody>
                  <tr>
                    <td>
                      Cardiac disease ?:<span>{{
                        PrintAntenatalVisitReportG.cardiac_disease == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Kidney disease ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.kidneydisease == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                    <td>
                      Hypertension :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.hypertension == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Tuber Culosis ?:<span>{{
                        PrintAntenatalVisitReportG.tuber_culosis == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Asthma ? :
                      <span>
                        {{ PrintAntenatalVisitReportG.asthma == 1 ? "Yes" : "No" }}</span
                      >
                    </td>
                    <td>
                      Sickle cell anaemia ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.sickle_cell_anaemia == 1
                            ? "Yes"
                            : "No"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Blood Transfusion?:<span>{{
                        PrintAntenatalVisitReportG.bloodTransfusion == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Ectopic pregnancy ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.ectopicpregnancy == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                    <td>
                      Epilepsy ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.epilepsy == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Tuber Culosis ?:<span>{{
                        PrintAntenatalVisitReportG.tuber_culosis == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Molar pregnancy ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.molar_pregnancy == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                    <td>
                      Diabetic ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.diabetic == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Cesarean Section?:<span>{{
                        PrintAntenatalVisitReportG.cesareanSection == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Manual Vacuum Aspiration ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.manualVacuumAspiration == 1
                            ? "Yes"
                            : "No"
                        }}</span
                      >
                    </td>
                    <td>
                      Major surgery ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.majorsurgery == 1 ? "Yes" : "No"
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-if="PrintAntenatalVisitReportG.majorsurgery == 1">
                    <td>
                      Major surgery name ?:<span>{{
                        PrintAntenatalVisitReportG.major_surgery_name
                          ? PrintAntenatalVisitReportG.major_surgery_name
                          : "---"
                      }}</span>
                    </td>

                    <td>
                      When ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.When_major_surgery
                            ? PrintAntenatalVisitReportG.When_major_surgery
                            : "---"
                        }}</span
                      >
                    </td>
                    <td>
                      Hospital? :
                      <span>
                        {{ PrintAntenatalVisitReportG.major_surgery_hospital }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>
                      Retained placenta?:<span>{{
                        PrintAntenatalVisitReportG.retainedPlacenta == 1 ? "Yes" : "No"
                      }}</span>
                    </td>

                    <td>
                      Postpartum hemorrhage ? :
                      <span>
                        {{
                          PrintAntenatalVisitReportG.postpartumHemorrhage == 1
                            ? "Yes"
                            : "No"
                        }}</span
                      >
                    </td>
                    <td>
                      Do you smoke? :
                      <span>
                        {{ PrintAntenatalVisitReportG.smoke == 1 ? "Yes" : "No" }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td>Family History?</td>
                    <td>{{ PrintAntenatalVisitReportG.familyHistory }}</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td>
                      Last Menstruation Period (LMP)?:<span>{{
                        PrintAntenatalVisitReportG.last_menstruation
                      }}</span>
                    </td>

                    <td>
                      Expected Delivery date (EDD)?:
                      <span> {{ PrintAntenatalVisitReportG.expectedDelivery }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td>Physical Examination?</td>
                    <td v-html="PrintAntenatalVisitReportG.physicalExamination"></td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <thead class="custom-table-header-success">
                  <tr>
                    <th scope="col">SERVICE</th>
                    <th scope="col">QTY</th>
                    <th scope="col">COST</th>
                    <th scope="col">TIME</th>
                    <th scope="col">STATUS</th>
                    >
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(service, index) in PrintAntenatalVisitReportG.visit
                      ? PrintAntenatalVisitReportG.visit.labrequests
                      : []"
                    :key="index"
                  >
                    <td>
                      {{ service.test ? service.test.name : "--"
                      }}<sup v-if="service.spouse">Spouse</sup> <sup v-else></sup>
                    </td>
                    <td>{{ service.quantity ? service.quantity : "--" }}</td>
                    <td>{{ service.amount ? service.amount : "--" }}</td>
                    <td>{{ service.date ? service.date : "--" }}</td>
                    <td>Pending...</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr
                    v-for="(service, index) in PrintAntenatalVisitReportG.visit
                      ? PrintAntenatalVisitReportG.visit.completetests
                      : []"
                    :key="index"
                  >
                    <td>
                      {{ service.test ? service.test.name : "--"
                      }}<sup v-if="service.spouse">Spouse</sup> <sup v-else></sup>
                    </td>
                    <td>{{ service.quantity ? service.quantity : "--" }}</td>
                    <td>{{ service.amount ? service.cost : "--" }}</td>
                    <td>{{ service.date ? service.date : "--" }}</td>
                    <td>Done</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr
                    v-for="(service, index) in PrintAntenatalVisitReportG.visit
                      ? PrintAntenatalVisitReportG.visit.patientservices
                      : []"
                    :key="index"
                  >
                    <td>
                      {{ service.service ? service.service.name : "--" }}
                      <sup v-if="service.spouse">Spouse</sup> <sup v-else></sup>
                    </td>
                    <td>{{ service.serviceQty ? service.serviceQty : "--" }}</td>
                    <td>{{ service.servicePrice ? service.servicePrice : "--" }}</td>
                    <td>{{ service.dateCreated ? service.dateCreated : "--" }}</td>
                    <td>
                      {{ service.serviceStatus == 1 ? "Done" : "Pending.." }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table mb-0">
                <thead class="custom-table-header">
                  <tr>
                    <th>S/N</th>
                    <th>Drug</th>
                    <th>Quantity</th>
                    <th>Cost</th>
                    <th>Payment Type</th>
                    <th>Medication</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(drug, index) in PrintAntenatalVisitReportG.visit
                      ? PrintAntenatalVisitReportG.visit.prescriptions
                      : []"
                    :key="index"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ drug.item.serviceName }}</td>
                    <td>{{ drug.itemQty }}</td>
                    <td>{{ drug.itemPrice }}</td>
                    <td>
                      {{ (drug.isInsured = 1 ? "Insurance Bill" : "Personal Bill") }}
                    </td>
                    <td>{{ drug.medication ? drug.medication : "----" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="table-responsive">
            <br />
            <br />
            <table width="50%" style="font-size: 17px">
              <tr>
                <center>
                  <p>Signature ..........................................</p>
                </center>
              </tr>
              <tr>
                <td>
                  <center>
                    Thank you for trusting
                    {{
                      PrintAntenatalVisitReportG.clinic_name
                        ? PrintAntenatalVisitReportG.clinic_name
                        : "---"
                    }}
                  </center>
                </td>
              </tr>
              <tr>
                <td>
                  <center>
                    For more inquiries call
                    {{
                      PrintAntenatalVisitReportG.clinic_contact
                        ? PrintAntenatalVisitReportG.clinic_contact
                        : "---"
                    }}
                  </center>
                </td>
              </tr>

              <tr>
                <div style="text-align: center">
                  <p>
                    Report Printed by
                    {{
                      PrintAntenatalVisitReportG.printuser
                        ? PrintAntenatalVisitReportG.printuser
                        : "---"
                    }}
                    via Clinic Plus Hospital Software
                  </p>
                </div>
              </tr>
            </table>
          </div>
          <div class="image" v-show="PrintAntenatalVisitReportG.clinic_stamp">
            <img :src="PrintAntenatalVisitReportG.clinic_stamp" alt="stamp" />
            <div class="stamp_date">{{ PrintAntenatalVisitReportG.printDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
